export const getThemeMode = (mode: string): string => {
  return mode === 'LIGHT' ? 'light' : 'dark'
}
